import axios from "axios";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";

function MatchesDisplay({ matches, setClickedUser }) {
  const [matchedProfiles, setMatchedProfiles] = useState(null);
  const [cookies, setCookie, removeCookie] = useCookies(null);

  const userId = cookies.UserId;

  const matchedUserIds = matches.map(({ user_id }) => user_id);
  //final fix
  const getMatches = async () => {
    try {
      const response = await axios.get(
        "https://tinder-casafurix.herokuapp.com/users",
        {
          params: { userIds: JSON.stringify(matchedUserIds) },
        }
      );
      setMatchedProfiles(response.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getMatches();
  }, [matches]);

  // console.log(matchedProfiles);

  //function to make sure that users can chat with each other, when both have equally right-swiped on each other!
  const filteredMatchedProfiles = matchedProfiles?.filter(
    (matchedProfile) =>
      matchedProfile.matches.filter((profile) => profile.user_id === userId)
        .length > 0
  );

  return (
    <div className='matches-display'>
      {filteredMatchedProfiles?.map((match) => (
        <div
          key={match.user_id}
          className='match-card'
          onClick={() => setClickedUser(match)}
        >
          <div className='img-container'>
            <img src={match?.url} alt={match?.first_name + " profile"} />
          </div>
          <h3>{match?.first_name}</h3>
        </div>
      ))}
    </div>
  );
}

export default MatchesDisplay;
